// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1AfHg","tab":"Tabs_tab__Nxi73","tabActive":"Tabs_tabActive__1e8ca"};